import { gql } from '@apollo/client';

export const GET_USER_BY_ID = gql`
  query Practitioner($id: ID!) {
    user: Practitioner(id: $id) {
      id
      name {
        prefix
        suffix
        family
        given
      }
      telecom {
        use
        value
        system
        rank
      }
      photo {
        url
        contentType
        title
      }
      address {
        city
        country
        state
        district
        postalCode
        line
        text
      }
      active
      gender
      birthDate
      practitionerRole: PractitionerRoleList(_reference: practitioner) {
        id
        code {
          coding {
            system
            code
            display
          }
        }
        specialty {
          coding {
            system
            code
            display
          }
        }
      }
    }
  }
`;

export const USER_ROLES = gql`
  query ValueSets {
    roles: ValueSetList(
      url: "https://fluentinhealth.com/FHIR/ValueSet/BOOMPractitionerRoles"
    ) {
      id
      compose {
        include {
          concept {
            code
            display
          }
          system
        }
      }
    }
  }
`;
